import * as ExcelJS from 'exceljs';
import {ExcelUsageDto} from './dto/usage-excel.dto';
import {pixelToPtHeight, pixelToPtWidth} from '../../utils/pixel-to-pt';
import {defaultStyle} from '../../utils/default-style';
import {
  defaultPageSetup,
  makeCell,
} from '../../utils/excel-default-setup';
import * as FileSaver from 'file-saver';
import 'reflect-metadata';

/**
 * 사용량 등록 서비스
 * @public
 */
export class UsageRegistersService {
  /**
   * 사용량 엑셀 파일 생성
   * @param params - 사용량 엑셀 DTO
   */
  async excelUsage(params: ExcelUsageDto) {
    const wb = new ExcelJS.Workbook();
    const workSheetName = '사용자수';
    const ws = wb.addWorksheet(workSheetName, defaultPageSetup());

    let calculatedRowLength = params.usageList.length;
    for (let i = 0; i < calculatedRowLength; i++) {
      const rowData = [];
      for (let j = 0; j < 48; j++) {
        rowData.push(' ');
      }
      ws.addRow(rowData);
    }

    // TODO! 여러 페이지의 프린트 영역 적용 안됨 맨 마지막만 프린트됨
    // ws.pageSetup.printArea = 'A1:AV10&&A12:AV14&&A15:AV17&&A19:AV22';

    // default style 설정
    ws.eachRow((row, rowIndex) => {
      row.eachCell((cell, colIndex) => {
        ws.getRow(cell.fullAddress.row).height = pixelToPtHeight(40);
        ws.getColumn(cell.fullAddress.col).width = pixelToPtWidth(40);
        // if (!emptyCellList.includes(cell.fullAddress.row))
        // ws.getCell(cell.address).style = defaultStyle;
      });
    });

    // 값 세팅
    params.usageList.forEach(item => {
      makeCell(ws, item.categoryCell, defaultStyle);
      makeCell(ws, item.textValueCell, defaultStyle);
    });

    // Excel 파일의 데이터 가져오기
    const buffer = await wb.xlsx.writeBuffer();

    // xlsx 라이브러리를 사용하여 Blob 생성
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // await wb.xlsx.writeFile(`${workSheetName}.xlsx`);
    FileSaver.saveAs(blob, `${workSheetName}.xlsx`);
  }
}
